import { render, staticRenderFns } from "./BurgerNavCross.vue?vue&type=template&id=08024699"
import script from "./BurgerNavCross.vue?vue&type=script&lang=js"
export * from "./BurgerNavCross.vue?vue&type=script&lang=js"
import style0 from "./BurgerNavCross.vue?vue&type=style&index=0&id=08024699&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports